import { RootState } from '../store';

export const selectUser = (state: RootState) => state.session.user;
export const selectDisableGoogleLogin = (state: RootState) => state.session.disableGoogleLogin;
export const selectToken = (state: RootState) => state.session.token;
export const selectRefreshToken = (state: RootState) => state.session.refreshToken;
export const selectIsRefreshingToken = (state: RootState) => state.session.isRefreshingToken;
export const selectAuthStatus = (state: RootState) => state.session.authStatus;
export const selectScreen = (state: RootState) => state.session.screen;
export const selectMode = (state: RootState) => state.session.mode;
export const selectCompatibilityInfos = (state: RootState) => state.session.compatibilityInfos;
export const selectMicrophone = (state: RootState) => state.session.microphone;
export const selectWrapperAppData = (state: RootState) => state.session.wrapperAppData;

export default {
  selectUser,
  selectDisableGoogleLogin,
  selectToken,
  selectRefreshToken,
  selectIsRefreshingToken,
  selectAuthStatus,
  selectScreen,
  selectMode,
  selectCompatibilityInfos,
  selectMicrophone,
  selectWrapperAppData,
};
